"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs3/helpers/interopRequireWildcard");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.Grid = exports.ResponsiveGrid = void 0;

var _jsxRuntime = require("react/jsx-runtime");

var _react = require("@fluentui/react");

var React = _interopRequireWildcard(require("react"));

var _getResponsiveStepValues = require("../styling/getResponsiveStepValues");

var _stylingConstants = require("../styling/stylingConstants");

var _useResponsiveMode = require("../styling/useResponsiveMode");

var _decorateChildren2 = require("./_decorateChildren");

var _filterChildren2 = require("./_filterChildren");

var _sortChildren2 = require("./_sortChildren");

var _ResponsiveGridContext = require("./ResponsiveGridContext");

var getClassNames = (0, _react.classNamesFunction)();
/**
 * Create grid (row -> column) layouts which change size, padding, order, and
 * direction based on Office UI Fabric `ResponsiveMode` steps.
 *
 * Responsive steps, padding, and pivot state are inherited by descendent
 * columns and rows.
 */

var ResponsiveGridBase = function ResponsiveGridBase(_ref) {
  var className = _ref.className,
      _ref$responsiveSteps = _ref.responsiveSteps,
      responsiveSteps = _ref$responsiveSteps === void 0 ? [] : _ref$responsiveSteps,
      responsivePivot = _ref.responsivePivot,
      rowPadding = _ref.rowPadding,
      columnPadding = _ref.columnPadding,
      styles = _ref.styles,
      children = _ref.children;
  var classes = getClassNames(styles);
  var responsiveMode = (0, _useResponsiveMode.useResponsiveMode)();
  var pivot = responsivePivot !== undefined && responsiveMode <= responsivePivot;
  children = (0, _filterChildren2._filterChildren)(children, responsiveMode, responsiveSteps);
  children = (0, _sortChildren2._sortChildren)(children, responsiveMode, responsiveSteps);
  children = (0, _decorateChildren2._decorateChildren)(children);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: (0, _react.css)('ms-ResponsiveGrid', className, classes.root),
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_ResponsiveGridContext.ResponsiveGridContext.Provider, {
      value: {
        responsiveSteps: responsiveSteps,
        pivot: pivot,
        row: {
          padding: (0, _getResponsiveStepValues.getResponsiveStepValues)(rowPadding, [_stylingConstants.gridUnit])
        },
        column: {
          padding: (0, _getResponsiveStepValues.getResponsiveStepValues)(columnPadding, [_stylingConstants.gridUnit])
        }
      },
      children: children
    })
  });
};

var ResponsiveGrid = (0, _react.styled)(ResponsiveGridBase, {
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'stretch',
    justifyContent: 'flex-start'
  }
});
exports.Grid = exports.ResponsiveGrid = ResponsiveGrid;